import React from "react";
import { Grid, TextField, Checkbox, FormControlLabel } from "@mui/material";

const Equipment = ({ formData, handleInputChange }) => {
  const equipmentFields = [
    {
      name: "minimumPoidsDisquesDeBarre",
      label: "Poids Min. Disques de Barre",
    },
    { name: "minimumHalteres", label: "Poids Min. Haltères" },
  ];

  const checkboxFields = [
    { name: "rackSquat", label: "Rack Squat" },
    { name: "bancHyperextension", label: "Banc Hyperextension" },
    { name: "reverseHyperMachine", label: "Reverse Hyper Machine" },
    { name: "gluteHamRaise", label: "Glute Ham Raise" },
    { name: "standingCalfRaise", label: "Standing Calf Raise" },
    { name: "ceintureDipTraction", label: "Ceinture Dip/Traction" },
    { name: "extensionJambes", label: "Extension Jambes" },
    { name: "paireDeGenouilleres", label: "Paire de Genouillères" },
    { name: "seatedCalfRaise", label: "Seated Calf Raise" },
    { name: "trx", label: "TRX" },
    { name: "sanglePowerlifting", label: "Sangle Powerlifting" },
    { name: "chainesPowerlifting", label: "Chaînes Powerlifting" },
    { name: "tourACables", label: "Tour à Câbles" },
  ];

  return (
    <>
      {equipmentFields.map((field) => (
        <Grid item xs={12} sm={6} key={field.name}>
          <TextField
            label={field.label}
            name={field.name}
            value={formData[field.name]}
            onChange={handleInputChange}
            fullWidth
          />
        </Grid>
      ))}
      {checkboxFields.map((field) => (
        <Grid item xs={12} sm={6} key={field.name}>
          <FormControlLabel
            control={
              <Checkbox
                checked={formData[field.name]}
                onChange={(e) =>
                  handleInputChange({
                    target: { name: field.name, value: e.target.checked },
                  })
                }
              />
            }
            label={field.label}
          />
        </Grid>
      ))}
    </>
  );
};

export default Equipment;
